module.exports = __webpack_public_path__ + "static/media/3.bc9c0193.jpg";